<zxing-scanner #scanner [enable]="enableScanner" (scanSuccess)="scanSuccess($event)" (scanError)="scanError($event)"
    (scanComplete)="scanComplete($event)">
</zxing-scanner>